<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>
    <button
      (click)="navigateBack()"
      class="offcanvas-title-btn">
      <i class="iconoir-nav-arrow-left"></i>
      {{ title }}
    </button>
  </ng-container>
  <ng-container body>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()">
        <bo-non-field-errors />
        <!-- Block card form for all users -->
        <div class="text-center mb-4">
          <img
            ngSrc="../../../../../assets/graphics/lady-lock.svg"
            alt=""
            width="180"
            height="144" />
        </div>
        <ng-content select="[blockCardHeading]"></ng-content>
        <div class="mb-3">
          <label
            class="mb-2 fw-600"
            for="blockCardRadioFraud">
            Please provide a reason
          </label>

          <div class="row row-cols-1 mb-3">
            @for (option of selectOptions(); track option.value) {
              <div class="col">
                <div class="form-check input-radio-select">
                  <input
                    class="form-check-input"
                    [checked]="option.checked"
                    (change)="onSelectOption(option.value)"
                    type="radio"
                    name="optionFields"
                    [id]="'option_' + option.value" />
                  <label
                    class="form-check-label"
                    [ngClass]="{ 'border-secondary': option.checked }"
                    [for]="'option_' + option.value">
                    {{ option.label }}
                  </label>
                </div>
              </div>
              @if (option.value === getSelectedOption()?.value) {
                @if (
                  getSelectedOption()?.value === CardBlockReason.Fraud ||
                  getSelectedOption()?.value === CardBlockReason.Lost ||
                  getSelectedOption()?.value === CardBlockReason.Stolen
                ) {
                  <div class="small text-secondary mb-2">The card will be permanently blocked.</div>
                } @else if (getSelectedOption()?.value === CardBlockReason.Other) {
                  <div class="small text-secondary mb-3">The card will be temporarily blocked.</div>
                }
              }
            } @empty {
              <p class="text-muted">No options available</p>
            }
          </div>
        </div>

        @if (getSelectedOption()?.value === CardBlockReason.Other) {
          <app-form-field
            [boFieldPath]="'block_reason_other'"
            [placeholder]="'Specify why you would like to block this card.'"
            [label]="'Please specify why'"
            [textArea]="{ rows: 6, cols: 0 }"></app-form-field>
        }
        <div class="row gy-3 offcanvas-buttons">
          <div class="col-12 col-sm-auto">
            <button
              type="button"
              class="btn btn-outline-dark"
              (click)="close()">
              Cancel
            </button>
          </div>
          <div class="col-12 col-sm-auto ms-sm-auto">
            <app-submit
              [busy]="busy"
              btnID="blockCardSubmitBtn"
              [icon]="false"
              [disabled]="!getSelectedOption() || (getSelectedOption()?.value === CardBlockReason.Other && !form.valid)"
              label="Block card"></app-submit>
          </div>
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
